module.exports = __webpack_public_path__ + "static/media/mdg3__.e4c26682.svg";